import { render, staticRenderFns } from "./Triangle5Footer.vue?vue&type=template&id=63b09ae9&"
import script from "./Triangle5Footer.vue?vue&type=script&lang=js&"
export * from "./Triangle5Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports